"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = exports.retrieve = exports.clear = void 0;
var firefly_utilities_helper_ts_1 = require("firefly-utilities-helper-ts");
function clear(key) {
    // @ts-ignore
    window[key] = undefined;
}
exports.clear = clear;
function retrieve(key) {
    var value = window[key];
    if (value !== undefined) {
        return value;
    }
}
exports.retrieve = retrieve;
function store(key, value) {
    if (firefly_utilities_helper_ts_1.isObject(value) || firefly_utilities_helper_ts_1.isArray(value)) {
        window[key] = value;
    }
}
exports.store = store;
